module.exports = __webpack_public_path__ + "media/images/svg/shopping-bag-fb7971965529374f1e3e6c45876043e4.svg";